import React, { Suspense, useState } from 'react'
import intl from 'react-intl-universal'
import { Script } from 'gatsby'
import SEO from './seo'
import Helmet from 'react-helmet'
import { hackMatchMedia } from '../utils'
import { useMedia } from '../hooks'
import { EnHeader } from '../components/header'
import { EnFooter } from '../components/footer'
import ContactBar from '../components/contact-bar'
import GlobalStyle from '../theme/global-style'
import { LocaleService } from '../services/locale-service'
import styled, { ThemeProvider } from 'styled-components'
import Scripts from './scripts'
import { Media, typography, color, spacing, Hack } from '../theme'
import { LOCALES } from '../services/locale-service'
import MobileConcact from './contact-bar/mobile-concact-bar'
import Disclaimer from './disclaimer'
import { ShowAtMobile } from './phone'
import TopNotice from './topnotice/topnotice'
const Main = styled.main`
  padding-top: ${p => (p.filled ? '0' : '60px')};
  min-height: calc(100vh - 366px);
  ${Media.phone`
    padding-top: ${p => (p.filled ? '0' : '.9rem')};
  `}
`
export const SeoH1 = styled.h1`
  text-indent: -9999;
  visibility: hidden;
  height: 0;
  width: 0;
`

const isInMain = process.env.GATSBY_PACKAGE_NAME === 'main'
// 修复在Safari 13 会白屏的问题
hackMatchMedia()

const Layout = ({
  children,
  location,
  isWithoutFooter,
  isWithoutHeader,
  isWithoutConcactBar,
  friendLinks,
  pageType,
  path,
  scaled,
  filled,
  showH1 = true,
  isTransparent = false,
  showBanner = false,
}) => {
  const locale = intl.getInitOptions().currentLocale
  const theme = { typography: typography[LOCALES.EN], color: color[LOCALES.EN], spacing }
  const isApplyPage = pageType === 'apply'
  const [showTopNotice, setShowTopNotice] = useState(() => {
    if (typeof window !== 'undefined') {
      const topNoticeClosed = sessionStorage.getItem('topNoticeClosed') === 'true'
      return !topNoticeClosed && !window.location.pathname.includes('/apply/exhibition')
    }
    return false
  })

  const lang = LocaleService.getLocale()
  const handleTopNoticeClose = () => {
    setShowTopNotice(false)
    if (typeof window !== 'undefined') {
      sessionStorage.setItem('topNoticeClosed', 'true')
    }
  }

  return (
    <ThemeProvider theme={{ ...theme, Hack: new Hack(locale) }}>
      <>
        <Scripts lang={lang} pageType={pageType} path={path || location.pathname} />
        <Script
          id='gtm-script'
          dangerouslySetInnerHTML={{
            __html: `
            (function (w, d, s, l, i) {
              w[l] = w[l] || []
              w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
              var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != 'dataLayer' ? '&l=' + l : ''
              j.async = true
              j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
              f.parentNode.insertBefore(j, f)
            })(window, document, 'script', 'dataLayer', 'GTM-K47QGDQ');
          `,
          }}
        />
        <Script id='gtag-script' src='https://www.googletagmanager.com/gtag/js?id=AW-656105564' forward={[`gtag`]} />
        <Script
          id='gtag-config'
          dangerouslySetInnerHTML={{
            __html: `window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                  gtag('js', new Date());
                  gtag('consent', 'default', {
                    'ad_storage': 'granted',
                    'ad_user_data': 'granted',
                    'ad_personalization': 'granted',
                    'analytics_storage': 'granted'
                  });
                  gtag('config', 'AW-656105564');
            `,
          }}
        />
        <Script
          id='clarity-config'
          dangerouslySetInnerHTML={{
            __html: `(function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "n87ks1rmlt");`,
          }}
        />
        <Helmet
          htmlAttributes={{
            lang,
            rel: 'alternate',
          }}
        >
          <meta name='msvalidate.01' content='CD87AF6F79D15C287D6191524408F1FA' />
          <meta name='viewport' content={`width=device-width, initial-scale=${scaled ? 0 : 1}`} />
          <meta name='google-site-verification' content='O30VZVPtqqQeC1WI1A1G6yjP7muHxArtzmnUXqIFfoQ' />
        </Helmet>
        {pageType && (
          <SEO
            title={intl.get(`${pageType}.seo.title`)}
            keywords={intl.get(`${pageType}.seo.keywords`)}
            description={intl.get(`${pageType}.seo.desc`)}
          />
        )}
        {isInMain && showH1 ? (
          <SeoH1>
            {intl.get(`${pageType}.seo.h1`) ? intl.get(`${pageType}.seo.h1`) : intl.get(`${pageType}.seo.title`)}
          </SeoH1>
        ) : null}
        {showTopNotice && <TopNotice onClose={handleTopNoticeClose} />}
        {!isWithoutHeader && (
          <EnHeader
            location={location}
            isApplyPage={isApplyPage}
            isTransparent={isTransparent}
            pageType={pageType}
            showTopNotice={showTopNotice}
          />
        )}
        <Main type={pageType} filled={filled}>
          {children}
        </Main>
        {!isWithoutFooter && (
          <Suspense fallback={null}>
            <EnFooter friendLinks={friendLinks} showBanner={showBanner} location={location} pageType={pageType} />
          </Suspense>
        )}
        <Disclaimer />
        {!isWithoutConcactBar ? (
          <>
            <ContactBar />
            <ShowAtMobile>{!isApplyPage ? <MobileConcact /> : null}</ShowAtMobile>
          </>
        ) : null}
        <GlobalStyle></GlobalStyle>
      </>
    </ThemeProvider>
  )
}

export default Layout
